import { pages } from '@constants/pages';
import { useDimensions } from '@hooks/useDimensions';
import { Calculator, FileText, Heart, Pill, Shuffle } from 'lucide-react';
import { Link } from 'react-router';

import { TreatmentCategories } from './TreatmentCategories';

function Home() {
  const { width } = useDimensions();

  return (
    <div>
      <TreatmentCategories />
      <h1 className="text-primary mt-12 text-2xl font-medium">Ferramentas</h1>
      <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
        <Link
          className="border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg border-2 p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
          to={pages.calculators.list}>
          <Calculator
            className="text-primary size-6 lg:size-8"
            strokeWidth={1.5}
          />
          Calculadoras
        </Link>

        <Link
          className="border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg border-2 p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
          to={pages.medicines.list}>
          <Pill className="text-primary size-6 lg:size-8" strokeWidth={1.5} />
          Medicamentos
        </Link>

        <Link
          className="border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg border-2 p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
          to="/anotacoes">
          <FileText
            className="text-primary size-6 lg:size-8"
            strokeWidth={1.5}
          />
          Minhas anotações
        </Link>
        {width < 768 && (
          <Link
            className="border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg border-2 p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
            to={pages.favorites}>
            <Heart
              className="text-primary size-6 lg:size-8"
              strokeWidth={1.5}
            />
            Favoritos
          </Link>
        )}
      </div>
      {width >= 768 && (
        <div className="mt-6 grid grid-cols-1 justify-center gap-6 sm:grid-cols-2 lg:grid-cols-[repeat(2,_0.4fr)] xl:grid-cols-[repeat(2,_0.33fr)]">
          <Link
            className="border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg border-2 p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
            to={pages.favorites}>
            <Heart
              className="text-primary size-6 lg:size-8"
              strokeWidth={1.5}
            />
            Favoritos
          </Link>
          <Link
            className="border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg border-2 p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
            to={pages.drugInteraction}>
            <Shuffle
              className="text-primary size-6 lg:size-8"
              strokeWidth={1.5}
            />
            Interações medicamentosas
          </Link>
        </div>
      )}
      {width < 768 && (
        <div className="mt-6 grid grid-cols-1 justify-center">
          <Link
            className="border-primary bg-background text-primary shadow-foreground/50 hover:shadow-foreground/60 flex items-center justify-center gap-2 rounded-lg border-2 p-3 text-base font-bold shadow-md transition-all hover:scale-[1.02] lg:p-5 lg:text-lg"
            to={pages.drugInteraction}>
            <Shuffle
              className="text-primary size-6 lg:size-8"
              strokeWidth={1.5}
            />
            Interações medicamentosas
          </Link>
        </div>
      )}
    </div>
  );
}

export default Home;
